<template>
  <v-app id="app">
    <v-main v-if="!getLoggedIn()">
      <router-view />
    </v-main>

    <template v-else>
      <NavigationSystem class="navigationtop" location="top" />
      <v-main>
        <router-view />
      </v-main>
      <FooterMenu />
    </template>

    <BeatLoader
      v-if="getLoginProcess()"
      class="spinnerloader"
      :loading="getLoginProcess()"
      color="var(--color-brand)"
      size="10rem"
    />
  </v-app>
</template>

<script>
import { adminStore } from '@/stores/adminstore.js'
import { userStore } from '@/stores/userstore.js'
import { mapActions, mapState, mapGetters } from 'pinia'
import { useToast } from 'vue-toastification'
// import { inject } from "vue";

// import offline from "./injects/offline.js";
// import update from "./injects/update.js";
import { BeatLoader } from 'vue3-spinner'
import app from '@/../package.json'

import FooterMenu from '@/components/menues/FooterMenu.vue'
import NavigationSystem from '@/components/menues/NavigationSystem.vue'

export default {
  name: 'App',
  components: {
    FooterMenu,
    NavigationSystem,
    BeatLoader
  },
  inject: [],
  beforeRouteEnter(to, from, next) {
    console.error('------- APP VUE BEFORE ENTER -------- ')
    console.log('to: (%o) from: (%o) next: (%o)', to, from, next)
  }, // "update", "offline"
  setup() {},
  data() {
    return {
      toast: useToast(),
      snackbarTimeout: -1,
      isOnline: false,
      isOffline: false,
      incrementSeconds: 0,
      updateExists: false
      // aStore: null,
    }
  },
  beforeMount() {
    console.info(
      '%c(c) LearningHub AS\n%cDeveloped in collaboration with \nSarpsborg municipality \n%cVersion (%s)',
      'background: rgba(12, 77, 161, 0.8); color: hsl(0, 0%, 100%); font-size:1.3rem; font-weight:800;',
      'background:  rgba(12, 77, 161, 0.8); color: hsl(0, 0%, 100%);',
      'background:  rgba(12, 77, 161, 0.8); color: hsl(0, 0%, 100%); font-size: 0.8rem: font-weight:300;',
      app.version
    )
    console.log('APP BEFORE MOUNT <<<<<<<<<<<<<')
    let aStore = adminStore()
    aStore.sitelanguage = localStorage.getItem('trlang')

    this.setLoggedIn(true)
    let serverUrlInfo = localStorage.getItem('hypsaserver')
    let registryUrlInfo = localStorage.getItem('hypregistry')
    this.setServerUrl(serverUrlInfo)
    console.log(
      '==== A P P  serverUrl: (' +
        serverUrlInfo +
        ') registryUrl(' +
        registryUrlInfo +
        ')'
    )
    if (!registryUrlInfo || !serverUrlInfo) {
      console.info(
        '*** MISSING SOME ESENNTIAL REGISTRY INFORMATION *** registry(%s) server(%s)',
        registryUrlInfo,
        serverUrlInfo
      )
      console.info('HOSTNAME (%s)', location.hostname)
      // @todo fix set to nothing...
      // localStorage.setItem('hypregistry', 'https://www.hypatia.no')
      if (location.hostname === 'skolestart.learning-hub.no') {
        this.setRegistryUrl('https://www.ataa.no/')
      } else if (location.hostname === 'stage-skolestart.learning-hub.no') {
        this.setRegistryUrl('https://www.ataa.no/stage/')
      } else if (location.hostname === 'skolestart.localhost') {
        this.setRegistryUrl('http://localhost/').then((res) => {
          console.log('setREgistryUrl returned (%j)', res)
        })
      }
    } else {
      this.setServerUrl(serverUrlInfo)
      this.pingServer()
        .then((result) => {
          console.log(
            'RESULT FOR APP - We have working connection with server !! '
          )
          console.log(result)
        })
        .catch((error) => {
          console.info(
            '*** ERROR *** could not get contact with PING server! ' + error
          )
          if (location.hostname === 'skolestart.learning-hub.no') {
            this.setRegistryUrl('https://www.ataa.no/')
          } else if (location.hostname === 'stage-skolestart.learning-hub.no') {
            this.setRegistryUrl('https://www.ataa.no/stage/')
          } else if (location.hostname === 'skolestart.localhost') {
            this.setRegistryUrl('http://localhost/')
          }
        })
    }
    if (location.hostname === 'skolestart.learning-hub.no') {
      this.setEnvironment('prod')
    } else if (location.hostname === 'stage-skolestart.learning-hub.no') {
      this.setEnvironment('stage')
    } else if (location.hostname === 'skolestart.localhost') {
      this.setEnvironment('dev')
    }
  },
  mounted() {
    console.log(
      '++++++++++ APP is mounted ++++++++ (%s)',
      this.isUserLoggedIn()
    )
    window.addEventListener('offline', () => {
      // Update your UI to reflect that there's no connection.
      console.warn('*** WARN *** we are OFFLINE !')
      this.geti18nTranslation('gui.offlinetext').then((translation) => {
        this.toast.info(translation)
      })
      this.isOnline = false
      this.isOffline = true
    })
    window.addEventListener('updateExists', () => {
      // Update your UI to reflect that the connection is back.
      console.info('WE HAVE UPDATES!!!!')
      console.warn('*** WARN *** we are back ONLINE !')
      this.geti18nTranslation('gui.updatetext').then((translation) => {
        this.toast.info(translation)
      })
      this.updateExists = true
      this.isOffline = false
      this.isOnline = true
    })
    window.addEventListener('online', () => {
      // Update your UI to reflect that the connection is back.
      console.warn('*** WARN *** we are back ONLINE !')
      this.geti18nTranslation('gui.onlinetext').then((translation) => {
        this.toast.info(translation)
      })
      this.isOffline = false
      this.isOnline = true
    })
    let datePayload = {
      toDate: this.$date().add(1, 'day').format('YYYY-MM-DD'),
      fromDate: this.$date()
        .subtract(2, 'month')
        .subtract(1, 'day')
        .format('YYYY-MM-DD')
    }
    // this.setSearchDate(datePayload); // SHOULD BE LOADED FROM STORES
  },
  methods: {
    ...mapActions(adminStore, [
      'setServerUrl',
      'setRegistryUrl',
      'applyRegistryUrl',
      'pingServer',
      'setEnvironment',
      'geti18nTranslation'
    ]),
    ...mapGetters(adminStore, ['getLoginProcess', 'getLoggedIn']),
    //    ...mapState(adminStore, []),
    ...mapActions(userStore, ['setLoggedIn']),
    ...mapState(userStore, ['isUserLoggedIn']),
    // setRegistryUrl() {},
    // setServerUrl() {},
    // setRegistryUrl() {},
    // pingServer() {},
    // setEnvironment() {},
    countSeconds() {
      setInterval(() => {
        let sec = this.incrementSeconds + 1
        this.incrementSeconds = sec
      }, 80)
    },
    checkLoggedIn() {
      return this.getLoggedIn()
    },
    checkRegistryServiceOK() {
      let registry = localStorage.getItem('hypsaserver')
      if (registry === undefined || registry === null || registry === '') {
        /*
        this.$router
          .push({
            name: "SetUrlForServerClient",
          })
          .catch(() => {});
          */
        // @todo should redirect to other places...
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.snackbarHeading {
  font-size: 2rem;
  font-weight: 800;
  margin: 1vh 2vw 1vh 2vw;
}

.snackbarText {
  font-size: 1.4rem;
  font-weight: 500;
  margin: 1vh 2vw 1vh 2vw;
}

.spinnerloader {
  position: fixed;
  top: 30%;
  left: 20%;
}
</style>
